import { memo, useState } from "react";
import { Flex, Image, Text } from "@chakra-ui/react";

type ProdutoData = {
	id: string;
	categoria: string;
	cod_barras: string;
	cod_pro: string;
	comiss_ind: number;
	comiss_ven: number;
	complementos: ComplementoData[];
	descricao: string;
	nome: string;
	obs: string;
	promocao: string;
	qtd: number;
	total: number;
	url_imagem: string;
	valor: number;
	valorFormatted: string;
	estoq_loja?: number;
	estoq_total?: number;
}
type ComplementoData = {
	codigo: number;
	grupo: number;
	nome: string;
	descricao: string;
	custo: number;
	valor: number;
	priceFormatted: string;
	qtd_maxima: number;
	qtd_gratis: number;
	qtd: number;
}
interface ItemProps {
	produto: ProdutoData;
	setProdutoItemModal: (produto: ProdutoData) => void;
	setIsNewItemModal: (open: boolean) => void;
	setIsAddNewItem: (add: boolean) => void;
}

function ItemComponent({
	produto,
	setProdutoItemModal,
	setIsNewItemModal,
	setIsAddNewItem,
}: ItemProps) {
/* const Item: React.FC<ItemProps> = ({ 
	produto,
	setProdutoItemModal,
	setIsNewItemModal,
	setIsAddNewItem,
}) => { */
	const [image, setImage] = useState(produto.url_imagem
		? produto.url_imagem
		: "https://safetycloud.blob.core.windows.net/cashback-promocoes/placeholder-image.png"
	);
	const [imageWH, setImageWH] = useState("155px");

	return (
		<Flex
			as="button"
			w="100%"
			p="4"
			justify="space-between"
			align="center"
			borderWidth={1}
			borderColor="gray.100"
			borderRadius="8"
			margin="0.5rem 0"
			_hover={{
				boxShadow: "0 0 3px rgba(0, 0, 0, 0.5)",
				transition: "boxShadow 0.9s",
			}}
			onClick={() => {
				setProdutoItemModal(produto);
				setIsNewItemModal(true);
				setIsAddNewItem(true);
			}}
		>
			<Flex flexDir="column" align="start">
				<Text
					align="start"
					color="gray.700"
					fontWeight="500"
					textTransform="capitalize"
				>
					{produto.nome}
				</Text>

				{produto.descricao && (
					<Text fontSize="15px" color="gray.500" align="start" mt="2">
						{produto.descricao}
					</Text>
				)}

				{(produto.estoq_loja || produto.estoq_loja === 0) && (
					<Text fontSize="15px" fontWeight="500" color="gray.800" mt="2">
						estoque loja: {produto.estoq_loja}
					</Text>
				)}

				{(produto.estoq_total || produto.estoq_total === 0) && (
					<Text fontSize="15px" fontWeight="500" color="gray.800">
						estoque total: {produto.estoq_total}
					</Text>
				)}

				<Text fontSize="15px" fontWeight="500" color="gray.800" mt="2">
					{produto.valorFormatted}
					 - 
					Cod. {produto.cod_barras}
				</Text>
			</Flex>

			<Flex
				justify="flex-end"
				w="auto"
				h="auto"
				m="2"
				maxW={imageWH} // {produto.url_imagem ? "155px" : "105px"}
				maxH={imageWH} //{produto.url_imagem ? "155px" : "105px"}
			>
				<Image
					h="auto"
					w="auto"
					ml="2"
					maxW={imageWH} // {produto.url_imagem ? "150px" : "100px"}
					maxH={imageWH} // {produto.url_imagem ? "150px" : "100px"}
					borderRadius="10"
					loading="lazy" // "eager"
					objectFit="cover"
					src={image}
					alt={produto.nome}
					onError={() => {
						setImageWH("100px");
						setImage("https://safetycloud.blob.core.windows.net/cashback-promocoes/image404.png");
					}}
					fallbackStrategy="beforeLoadOrError"
				/>
			</Flex>
		</Flex>
	)
}

// export default Item;

export const Item = memo(ItemComponent, (prevProps, nextProps) => {
	return Object.is(prevProps.produto, nextProps.produto)
});